/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AvailableEntitiesResponse,
  BadRequestResponse,
  EntityAttachPreviewResponse,
  EntityRecordsAttachableEntitiesByEntityTypeGetV2Params,
  EntityRecordsAvailableOnJobGetV2Params,
  EntityRecordsByEntityExternalIdGetV2200,
  EntityRecordsInsertPostV2200,
  EntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2Params,
  EntityRecordsLinkedEntitiesBySourceExternalIdGetV2Params,
  EntityRecordsLinkedEntitiesBySourceExternalIdPutV2Params,
  EntityRecordsLinkedEntitiesMassLinkPostV2Params,
  EntityType,
  ForbiddenResponse,
  GroupedLinkedEntitiesResponse,
  InsertEntityRecordRequest,
  LinkedEntitiesResponse,
  MassLinkRequest,
  MassLinkResponse,
  ReplaceLinksRequest,
  ReplaceLinksResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const entityRecordsAttachableEntitiesByEntityTypeGetV2 = (
  entityType: EntityType,
  params?: EntityRecordsAttachableEntitiesByEntityTypeGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<EntityAttachPreviewResponse>(
    {
      url: `/apix/v2/EntityRecords/${entityType}/attachable-entities`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getEntityRecordsAttachableEntitiesByEntityTypeGetV2QueryKey = (
  entityType?: EntityType,
  params?: EntityRecordsAttachableEntitiesByEntityTypeGetV2Params,
) => {
  return [
    `/apix/v2/EntityRecords/${entityType}/attachable-entities`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEntityRecordsAttachableEntitiesByEntityTypeGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof entityRecordsAttachableEntitiesByEntityTypeGetV2>
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  entityType: EntityType,
  params?: EntityRecordsAttachableEntitiesByEntityTypeGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof entityRecordsAttachableEntitiesByEntityTypeGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEntityRecordsAttachableEntitiesByEntityTypeGetV2QueryKey(
      entityType,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof entityRecordsAttachableEntitiesByEntityTypeGetV2>>
  > = ({ signal }) =>
    entityRecordsAttachableEntitiesByEntityTypeGetV2(
      entityType,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!entityType,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof entityRecordsAttachableEntitiesByEntityTypeGetV2>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntityRecordsAttachableEntitiesByEntityTypeGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof entityRecordsAttachableEntitiesByEntityTypeGetV2>>
  >;
export type EntityRecordsAttachableEntitiesByEntityTypeGetV2QueryError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

export function useEntityRecordsAttachableEntitiesByEntityTypeGetV2<
  TData = Awaited<
    ReturnType<typeof entityRecordsAttachableEntitiesByEntityTypeGetV2>
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  entityType: EntityType,
  params?: EntityRecordsAttachableEntitiesByEntityTypeGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof entityRecordsAttachableEntitiesByEntityTypeGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getEntityRecordsAttachableEntitiesByEntityTypeGetV2QueryOptions(
      entityType,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const entityRecordsInsertPostV2 = (
  insertEntityRecordRequest: BodyType<InsertEntityRecordRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<EntityRecordsInsertPostV2200>(
    {
      url: `/apix/v2/EntityRecords/insert`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: insertEntityRecordRequest,
      signal,
    },
    options,
  );
};

export const getEntityRecordsInsertPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof entityRecordsInsertPostV2>>,
    TError,
    { data: BodyType<InsertEntityRecordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof entityRecordsInsertPostV2>>,
  TError,
  { data: BodyType<InsertEntityRecordRequest> },
  TContext
> => {
  const mutationKey = ["entityRecordsInsertPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof entityRecordsInsertPostV2>>,
    { data: BodyType<InsertEntityRecordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return entityRecordsInsertPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EntityRecordsInsertPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof entityRecordsInsertPostV2>>
>;
export type EntityRecordsInsertPostV2MutationBody =
  BodyType<InsertEntityRecordRequest>;
export type EntityRecordsInsertPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

export const useEntityRecordsInsertPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof entityRecordsInsertPostV2>>,
    TError,
    { data: BodyType<InsertEntityRecordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof entityRecordsInsertPostV2>>,
  TError,
  { data: BodyType<InsertEntityRecordRequest> },
  TContext
> => {
  const mutationOptions = getEntityRecordsInsertPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const entityRecordsByEntityExternalIdGetV2 = (
  entityExternalId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<EntityRecordsByEntityExternalIdGetV2200>(
    {
      url: `/apix/v2/EntityRecords/${entityExternalId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getEntityRecordsByEntityExternalIdGetV2QueryKey = (
  entityExternalId?: string,
) => {
  return [`/apix/v2/EntityRecords/${entityExternalId}`] as const;
};

export const getEntityRecordsByEntityExternalIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof entityRecordsByEntityExternalIdGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  entityExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof entityRecordsByEntityExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEntityRecordsByEntityExternalIdGetV2QueryKey(entityExternalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof entityRecordsByEntityExternalIdGetV2>>
  > = ({ signal }) =>
    entityRecordsByEntityExternalIdGetV2(
      entityExternalId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!entityExternalId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof entityRecordsByEntityExternalIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntityRecordsByEntityExternalIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof entityRecordsByEntityExternalIdGetV2>>
>;
export type EntityRecordsByEntityExternalIdGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

export function useEntityRecordsByEntityExternalIdGetV2<
  TData = Awaited<ReturnType<typeof entityRecordsByEntityExternalIdGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  entityExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof entityRecordsByEntityExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEntityRecordsByEntityExternalIdGetV2QueryOptions(
    entityExternalId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Returns all entities of the specified type that are available to be linked on the specified job as entity records.
 */
export const entityRecordsAvailableOnJobGetV2 = (
  params?: EntityRecordsAvailableOnJobGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AvailableEntitiesResponse>(
    {
      url: `/apix/v2/EntityRecords/available-on-job`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getEntityRecordsAvailableOnJobGetV2QueryKey = (
  params?: EntityRecordsAvailableOnJobGetV2Params,
) => {
  return [
    `/apix/v2/EntityRecords/available-on-job`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEntityRecordsAvailableOnJobGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof entityRecordsAvailableOnJobGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: EntityRecordsAvailableOnJobGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof entityRecordsAvailableOnJobGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEntityRecordsAvailableOnJobGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof entityRecordsAvailableOnJobGetV2>>
  > = ({ signal }) =>
    entityRecordsAvailableOnJobGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof entityRecordsAvailableOnJobGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntityRecordsAvailableOnJobGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof entityRecordsAvailableOnJobGetV2>>
>;
export type EntityRecordsAvailableOnJobGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Returns all entities of the specified type that are available to be linked on the specified job as entity records.
 */

export function useEntityRecordsAvailableOnJobGetV2<
  TData = Awaited<ReturnType<typeof entityRecordsAvailableOnJobGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: EntityRecordsAvailableOnJobGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof entityRecordsAvailableOnJobGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEntityRecordsAvailableOnJobGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @deprecated
 * @summary Get all entity records of the specified type that are linked to the given entity, regardless of link direction.
Returns entities where the given ID is either the source or the target of the link.
NOTE: This endpoint currently only supports querying a single linked entity type at a time.
 */
export const entityRecordsLinkedEntitiesBySourceExternalIdGetV2 = (
  sourceExternalId: string,
  params?: EntityRecordsLinkedEntitiesBySourceExternalIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<LinkedEntitiesResponse>(
    {
      url: `/apix/v2/EntityRecords/linked-entities/${sourceExternalId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getEntityRecordsLinkedEntitiesBySourceExternalIdGetV2QueryKey = (
  sourceExternalId?: string,
  params?: EntityRecordsLinkedEntitiesBySourceExternalIdGetV2Params,
) => {
  return [
    `/apix/v2/EntityRecords/linked-entities/${sourceExternalId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEntityRecordsLinkedEntitiesBySourceExternalIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdGetV2>
    >,
    TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  >(
    sourceExternalId: string,
    params?: EntityRecordsLinkedEntitiesBySourceExternalIdGetV2Params,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdGetV2>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getEntityRecordsLinkedEntitiesBySourceExternalIdGetV2QueryKey(
        sourceExternalId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdGetV2>
      >
    > = ({ signal }) =>
      entityRecordsLinkedEntitiesBySourceExternalIdGetV2(
        sourceExternalId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sourceExternalId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdGetV2>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type EntityRecordsLinkedEntitiesBySourceExternalIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdGetV2>
    >
  >;
export type EntityRecordsLinkedEntitiesBySourceExternalIdGetV2QueryError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

/**
 * @deprecated
 * @summary Get all entity records of the specified type that are linked to the given entity, regardless of link direction.
Returns entities where the given ID is either the source or the target of the link.
NOTE: This endpoint currently only supports querying a single linked entity type at a time.
 */

export function useEntityRecordsLinkedEntitiesBySourceExternalIdGetV2<
  TData = Awaited<
    ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdGetV2>
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  sourceExternalId: string,
  params?: EntityRecordsLinkedEntitiesBySourceExternalIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getEntityRecordsLinkedEntitiesBySourceExternalIdGetV2QueryOptions(
      sourceExternalId,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Update the linked entities for a source entity to match passed in links.
 */
export const entityRecordsLinkedEntitiesBySourceExternalIdPutV2 = (
  sourceExternalId: string,
  replaceLinksRequest: BodyType<ReplaceLinksRequest>,
  params?: EntityRecordsLinkedEntitiesBySourceExternalIdPutV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<ReplaceLinksResponse>(
    {
      url: `/apix/v2/EntityRecords/linked-entities/${sourceExternalId}`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: replaceLinksRequest,
      params,
    },
    options,
  );
};

export const getEntityRecordsLinkedEntitiesBySourceExternalIdPutV2MutationOptions =
  <
    TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdPutV2>
      >,
      TError,
      {
        sourceExternalId: string;
        data: BodyType<ReplaceLinksRequest>;
        params?: EntityRecordsLinkedEntitiesBySourceExternalIdPutV2Params;
      },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdPutV2>
    >,
    TError,
    {
      sourceExternalId: string;
      data: BodyType<ReplaceLinksRequest>;
      params?: EntityRecordsLinkedEntitiesBySourceExternalIdPutV2Params;
    },
    TContext
  > => {
    const mutationKey = ["entityRecordsLinkedEntitiesBySourceExternalIdPutV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdPutV2>
      >,
      {
        sourceExternalId: string;
        data: BodyType<ReplaceLinksRequest>;
        params?: EntityRecordsLinkedEntitiesBySourceExternalIdPutV2Params;
      }
    > = (props) => {
      const { sourceExternalId, data, params } = props ?? {};

      return entityRecordsLinkedEntitiesBySourceExternalIdPutV2(
        sourceExternalId,
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EntityRecordsLinkedEntitiesBySourceExternalIdPutV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdPutV2>
    >
  >;
export type EntityRecordsLinkedEntitiesBySourceExternalIdPutV2MutationBody =
  BodyType<ReplaceLinksRequest>;
export type EntityRecordsLinkedEntitiesBySourceExternalIdPutV2MutationError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

/**
 * @summary Update the linked entities for a source entity to match passed in links.
 */
export const useEntityRecordsLinkedEntitiesBySourceExternalIdPutV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdPutV2>
    >,
    TError,
    {
      sourceExternalId: string;
      data: BodyType<ReplaceLinksRequest>;
      params?: EntityRecordsLinkedEntitiesBySourceExternalIdPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof entityRecordsLinkedEntitiesBySourceExternalIdPutV2>
  >,
  TError,
  {
    sourceExternalId: string;
    data: BodyType<ReplaceLinksRequest>;
    params?: EntityRecordsLinkedEntitiesBySourceExternalIdPutV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getEntityRecordsLinkedEntitiesBySourceExternalIdPutV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Get all entity records of the specified types that are linked to the given entity, regardless of link direction.
Returns entities where the given ID is either the source or the target of the link, grouped by entity type.
 */
export const entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2 = (
  sourceExternalId: string,
  params?: EntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GroupedLinkedEntitiesResponse>(
    {
      url: `/apix/v2/EntityRecords/linked-entities/${sourceExternalId}/batch`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getEntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2QueryKey =
  (
    sourceExternalId?: string,
    params?: EntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2Params,
  ) => {
    return [
      `/apix/v2/EntityRecords/linked-entities/${sourceExternalId}/batch`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getEntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2>
    >,
    TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  >(
    sourceExternalId: string,
    params?: EntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2Params,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getEntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2QueryKey(
        sourceExternalId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2
        >
      >
    > = ({ signal }) =>
      entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2(
        sourceExternalId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sourceExternalId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type EntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2>
    >
  >;
export type EntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2QueryError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

/**
 * @summary Get all entity records of the specified types that are linked to the given entity, regardless of link direction.
Returns entities where the given ID is either the source or the target of the link, grouped by entity type.
 */

export function useEntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2<
  TData = Awaited<
    ReturnType<typeof entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2>
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  sourceExternalId: string,
  params?: EntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof entityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getEntityRecordsLinkedEntitiesBatchBySourceExternalIdGetV2QueryOptions(
      sourceExternalId,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Additively creates links from multiple source entities to one or more target entity types
in a single operation. Existing links on each source entity are preserved.
 */
export const entityRecordsLinkedEntitiesMassLinkPostV2 = (
  massLinkRequest: BodyType<MassLinkRequest>,
  params?: EntityRecordsLinkedEntitiesMassLinkPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassLinkResponse>(
    {
      url: `/apix/v2/EntityRecords/linked-entities/mass-link`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massLinkRequest,
      params,
      signal,
    },
    options,
  );
};

export const getEntityRecordsLinkedEntitiesMassLinkPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof entityRecordsLinkedEntitiesMassLinkPostV2>>,
    TError,
    {
      data: BodyType<MassLinkRequest>;
      params?: EntityRecordsLinkedEntitiesMassLinkPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof entityRecordsLinkedEntitiesMassLinkPostV2>>,
  TError,
  {
    data: BodyType<MassLinkRequest>;
    params?: EntityRecordsLinkedEntitiesMassLinkPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["entityRecordsLinkedEntitiesMassLinkPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof entityRecordsLinkedEntitiesMassLinkPostV2>>,
    {
      data: BodyType<MassLinkRequest>;
      params?: EntityRecordsLinkedEntitiesMassLinkPostV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return entityRecordsLinkedEntitiesMassLinkPostV2(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type EntityRecordsLinkedEntitiesMassLinkPostV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof entityRecordsLinkedEntitiesMassLinkPostV2>>
  >;
export type EntityRecordsLinkedEntitiesMassLinkPostV2MutationBody =
  BodyType<MassLinkRequest>;
export type EntityRecordsLinkedEntitiesMassLinkPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Additively creates links from multiple source entities to one or more target entity types
in a single operation. Existing links on each source entity are preserved.
 */
export const useEntityRecordsLinkedEntitiesMassLinkPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof entityRecordsLinkedEntitiesMassLinkPostV2>>,
    TError,
    {
      data: BodyType<MassLinkRequest>;
      params?: EntityRecordsLinkedEntitiesMassLinkPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof entityRecordsLinkedEntitiesMassLinkPostV2>>,
  TError,
  {
    data: BodyType<MassLinkRequest>;
    params?: EntityRecordsLinkedEntitiesMassLinkPostV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getEntityRecordsLinkedEntitiesMassLinkPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
